import React from "react";
import { Container } from "@material-ui/core";
import styled from "styled-components";
import Layout from "../Shared/Layout";
import { Trans } from "../utils/i18n";
import MuiButton from "@material-ui/core/Button";
import { usePage, InertiaLink, } from "@inertiajs/inertia-react";
import DeviceWidget from "../FormComponents/DeviceWidget/DeviceWidget";
import {CheckCircle} from "@material-ui/icons";

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
`;

const SuccessWrapper = styled.div`
    padding: 1rem 1rem;
    margin-left: 25%;
    margin-right: 25%;
    margin-top: 3rem;
    margin-bottom: 3rem;
    border-radius: .5rem;
    text-align: center;
    color: #000;
`;

export default function OrderSuccessPage({ orderNumber }) {
    const { client, widgetData, problem1, problem2, product, serviceProduct, currentCountry } = usePage().props;
    const parcelCompany = currentCountry === 'US' ? 'UPS' : currentCountry === 'GB' ? 'Royal Mail' :  'UPS';

    return (
        <Wrapper>
            <Container maxWidth="md">
                <div className={'bg-blue-200 rounded-lg font-bold text-center p-1.5 text-lg mb-6 flex gap-2 justify-center items-center text-gray-900'}>
                    <CheckCircle />
                    <Trans i18nKey="order.confirmedRequest">
                        Confirmed request
                    </Trans>
                </div>
                <DeviceWidget values={widgetData} product={product} serviceProduct={serviceProduct} problem1={problem1} problem2={problem2}/>
                <h2>
                    <Trans i18nKey="formPage.yourOrderHasBeenPlaced">
                        Your Order has been placed
                    </Trans>
                </h2>
                <SuccessWrapper className={'bg-blue-100'}>
                    <p>
                        <Trans i18nKey="formPage.thanksForYourOrder">
                            Thanks for your Order
                        </Trans>
                    </p>
                    <p>
                        <b>{orderNumber}</b>
                    </p>
                </SuccessWrapper>
                {(client.key === "amazon" || client.key === "whitelabel") && (
                    <div>
                        <p>
                            <h2><Trans i18nKey="orderSuccess.description.title">What's next? Send us your device</Trans></h2>
                        </p>
                        <p className={'text-lg'}>
                            <Trans i18nKey="orderSuccess.description.text1" parcelCompany={parcelCompany}>Shortly we will send you a follow-up email with a pre-paid {{parcelCompany}} Return Label for your device. Further details and options about drop-off or collection will be included in that email.</Trans>
                        </p>
                        <p className={'text-lg'}>
                            <Trans i18nKey="orderSuccess.description.text2">Ahead of receiving your Return Label, please read our Shipment Requirements to help you be ready to return you device as quickly as possible:</Trans>
                        </p>
                        <p className={'text-lg'}>
                            <Trans i18nKey="orderSuccess.description.text3">1.    Backup any personal data on your device if applicable, before returning it for repair.</Trans>
                        </p>
                        <p className={'text-lg'}>
                            <Trans i18nKey="orderSuccess.description.text4">2.    Remove any personal account(s) and passwords from your device before returning it for repair.</Trans>
                        </p>
                        <p className={'text-lg'}>
                            {
                                currentCountry === 'US' ? (
                                        <Trans i18nKey="orderSuccess.description.text5US" >3.    Please securely package your device (we recommend a jiffy bag or padded box as minimum) to prevent further damage in transit*. Standard dimensions are expected to be 18 x 14 x 6 inches; up to 4.5 pounds in weight.</Trans>
                                )
                                    : (
                                        <Trans i18nKey="orderSuccess.description.text5" >3.    Please securely package your device (we recommend a jiffy bag or padded box as minimum) to prevent further damage in transit*. Standard dimensions are expected to be 45cm x 35cm x 16cm; up to 2 kg in weight.</Trans>
                                    )
                            }
                        </p>
                    </div>
                )}
                <div className={'text-right'}>
                    <MuiButton
                        style={{ marginTop: 50}}
                        variant="contained"
                        color={"secondary"}
                        href={'/'}
                        component={InertiaLink}
                    >
                        <Trans i18nKey="common.home">
                            Home
                        </Trans>
                    </MuiButton>
                </div>
            </Container>
        </Wrapper>
    );
}

OrderSuccessPage.layout = (page) => <Layout children={page} />;
